// Hooks
import { AlbumProvider } from '@/utils/hooks/context/useAlbumContext';

import PropTypes from 'prop-types';

// Components
import Modal from '@/components/base/Modal';
import { ModalSteps } from '@/components/pages/albums/AlbumFunnelModal/ModalSteps';

const FunnelModal = ({
    isOpen,
    toggle,
    params = {},
    callbackUpdateAlbum = () => {
        /** */
    }
}) => {
    return (
        <Modal open={isOpen} onDismiss={toggle} wrapperWidthFull={false} size="5xl">
            <AlbumProvider params={params}>
                <ModalSteps dismiss={toggle} callbackUpdateAlbum={callbackUpdateAlbum} />
            </AlbumProvider>
        </Modal>
    );
};

FunnelModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    toggle: PropTypes.func.isRequired,
    params: PropTypes.object
};

export default FunnelModal;
